module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAExSURBVHgBnZI/SwNBEMXfTC6FlyuSwkqQBAvNQSrBUoJtbKxFTDqblIJNQLQVRAM2gnddOsHaTyBipRCttLTSyF0EObPjpDg4JTF/XrX7dn77dpYhqIILd43ZbGGIRPAWAc1c7fEl9ij0FzcFvA9BQ0teB4EE5AHejWAqMaxg8SESWY+ND79YIZHZvzAzlbU8FRnT6NdS1y8+Z6rtQudsPmfZmWu9/bYncjMwWbhALKvCqFuxqdCe9nLl1NqH+Ecdv7Rsme8mJ75gBUSXGKFs9f5OgDlOmk5aQowhbSfNmFJ9UDCFWKnPdy+fxYSyQOY8DbulwRPB7Gw/nVAPp/rgmfDLLIwDiaZRvAm8pTIRHesUbSRn8hegRNd3jxiSouRB4Lk7RFLXpT0kLBJIy7FLBz8y525/DpNk2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copy@3x.png
// module id = cfad
// module chunks = 1